import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import api from "../../api";
import TaskQnA from "./TaskQnA";
import styles from "./TaskChatPage.module.css";

export default function TaskChatPage() {
  const location = useLocation();
  const [me, setMe]             = useState(null);
  const [tasks, setTasks]       = useState([]);
  const [notifs, setNotifs]     = useState([]);
  const [selected, setSelected] = useState(null);
  const [tab, setTab]           = useState(location.state?.tab || "unread_mine");

  useEffect(() => {
    api.get("/users/me/").then(res => setMe(res.data.id));
  }, []);

  useEffect(() => {
    Promise.all([
      api.get("/tasks/assigned/"),
      api.get("/tasks/received/"),
      api.get("/tasks/notifications/"),
    ]).then(([r1, r2, r3]) => {
      const all = [
        ...r1.data.map(t => ({ ...t, role: "assigner" })),
        ...r2.data.map(t => ({ ...t, role: "assignee" })),
      ];
      const seen = new Set();
      const unique = all.filter(t => {
        if (seen.has(t.id)) return false;
        seen.add(t.id);
        return true;
      });
      setTasks(unique.filter(t => t.comment_count > 0 && !t.chat_closed));

      setNotifs(r3.data);
    });
  }, []);

  const myUnreadIds = new Set(
    notifs.filter(n => !n.is_read).map(n => Number(n.task))
  );

  const myUnreadTasks    = tasks.filter(t => myUnreadIds.has(t.id));
  const otherUnreadTasks = tasks.filter(t =>
    !myUnreadIds.has(t.id) && t.last_comment_author === me
  );
  const displayTasks = tab === "unread_mine" ? myUnreadTasks : otherUnreadTasks;

  return (
    <div className={styles.wrap}>

      {/* 왼쪽 */}
      <div className={styles.left}>
        <div className={styles.leftTitle}>읽지 않은 업무</div>

        <div className={styles.tabRow}>
          <button
            className={`${styles.tabBtn} ${tab === "unread_mine" ? styles.tabOn : ""}`}
            onClick={() => setTab("unread_mine")}
          >
            내가 읽지 않은 업무
            {myUnreadTasks.length > 0 && (
              <span className={styles.badge}>{myUnreadTasks.length}</span>
            )}
          </button>
          <button
            className={`${styles.tabBtn} ${tab === "unread_other" ? styles.tabOn : ""}`}
            onClick={() => setTab("unread_other")}
          >
            상대방이 읽지 않은 업무
            {otherUnreadTasks.length > 0 && (
              <span className={styles.badge}>{otherUnreadTasks.length}</span>
            )}
          </button>
        </div>

        <div className={styles.taskList}>
          {displayTasks.length === 0 && (
            <div className={styles.empty}>해당하는 업무가 없습니다.</div>
          )}
          {displayTasks.map(t => (
            <div
              key={t.id}
              className={`${styles.taskItem} ${selected?.id === t.id ? styles.taskItemOn : ""}`}
              onClick={() => setSelected(t)}
            >
              <div className={styles.taskItemTitle}>
                {myUnreadIds.has(t.id) && <span className={styles.dot} />}
                {t.title}
              </div>
              <div className={styles.taskItemSub}>
                {t.role === "assigner" ? `수신: ${t.assignee_name}` : `지시: ${t.assigner_name}`}
                <span className={`${styles.statusBadge} ${styles["s_" + t.status]}`}>
                  {t.status_display}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* 오른쪽 */}
      <div className={styles.right}>
        {!selected ? (
          <div className={styles.placeholder}>왼쪽에서 업무를 선택하세요.</div>
        ) : (
          <>
            <div className={styles.detail}>
              <div className={styles.detailTitle}>{selected.title}</div>
              <div className={styles.detailGrid}>
                {[
                  ["지시자", selected.assigner_name],
                  ["수신자", selected.assignee_name],
                  ["중요도", "★".repeat(selected.priority) + "☆".repeat(3 - selected.priority)],
                  ["기한",   selected.due_date?.slice(0,16).replace("T"," ")],
                  ["상태",   selected.status_display],
                  ["지시일", selected.created_at?.slice(0,10)],
                ].map(([label, value]) => (
                  <div key={label} className={styles.detailItem}>
                    <span className={styles.detailLabel}>{label}</span>
                    <span className={styles.detailValue}>{value}</span>
                  </div>
                ))}
              </div>
              <div className={styles.detailContentLabel}>업무 내용</div>
              <div className={styles.detailContentBox}>{selected.content}</div>
            </div>

            <TaskQnA
              taskId={selected.id}
              currentUserId={me}
              onChatClosed={(id) => {
                setTasks(prev => prev.filter(t => t.id !== id));
                setSelected(null);
              }}
            />

          </>
        )}
      </div>

    </div>
  );
}